import { parseGapValue, parsePaddingValue } from '../parser';

const decomposeGapProperty = (value: string): Record<string, string | null> => {
  const gap = parseGapValue(value);

  return {
    rowGap: gap?.rowGap ?? null,
    columnGap: gap?.columnGap ?? null,
  };
};

const decomposePaddingProperty = (
  value: string,
): Record<string, string | null> => {
  const padding = parsePaddingValue(value);

  return {
    paddingTop: padding?.paddingTop ?? null,
    paddingRight: padding?.paddingRight ?? null,
    paddingBottom: padding?.paddingBottom ?? null,
    paddingLeft: padding?.paddingLeft ?? null,
  };
};

export const spacingDecomposeMap = {
  gap: decomposeGapProperty,
  padding: decomposePaddingProperty,
};
